import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '../utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'ring-offset-background border-foreground/30 peer h-[16px] w-[16px] shrink-0 rounded-sm border-[1.25px]',
      'hover:border-foreground',
      'active:bg-foreground/30',
      'focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden',
      'aria-checked:border-foreground aria-checked:bg-foreground aria-checked:text-background',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      <Check />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

function Check(props: { className?: string }) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-background size-3', props.className)}
    >
      <path d="M11.7471 3.3418C12.1107 2.92628 12.7426 2.88372 13.1582 3.24707C13.5737 3.61065 13.6163 4.24256 13.2529 4.65821L6.95606 11.8545C6.19415 12.7248 4.85505 12.7691 4.03711 11.9512L1.29297 9.20703C0.902445 8.81651 0.902445 8.1835 1.29297 7.79297C1.68349 7.40245 2.31651 7.40245 2.70703 7.79297L5.45117 10.5371L11.7471 3.3418Z" />
    </svg>
  )
}

export { Checkbox, Check }
